<template>
  <div>
    <CRow>
      <CCol col="12" lg="6">
        <CCard>
          <CCardHeader>
            <strong>Υποκατηγορία:</strong> {{ title }}
          </CCardHeader>
          <CCardBody>
              <CDataTable 
                striped 
                small 
                fixed
                :items="items" 
                :fields="fields"
              >
                <template slot="value" slot-scope="data">
                  <td><strong>{{data.item.value}}</strong></td>
                </template>
              </CDataTable>
          </CCardBody>
          <CCardFooter>
            <CButton color="primary" @click="goBack">Πίσω</CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Subcategory',
  data: () => {
    return {
      items: [],
      title: '',
      fields: [
        {key: 'key', label: 'Πεδίο'},
        {key: 'value', label: 'Τιμή'},
      ],
    }
  },
  methods: {
    getSubcategoryData (id) {
      const subcategory = subcategoryData.find((subcategory, index) => index + 1 == id)
      const subcategoryDetails = subcategory ? Object.entries(subcategory) : [['id', 'Not found']]
      return subcategoryDetails.map(([key, value]) => { return { key, value } })
    },
    goBack() {
      this.$router.go(-1)
    }
  },
  mounted: function(){
    let self = this;
    axios.get('/api/servicesubcategories/' + self.$route.params.id + '?token=' + localStorage.getItem("api_token"))
    .then(function (response) {
      //const items = response.data.services;
      const ser_items = Object.entries(response.data).map(([key, value]) => {return {key: key, value: value}});
      const keys = ["name", "service", "active"];
      self.items = ser_items.filter((t) => keys.includes(t.key));
      self.title = self.items.find((t) => t.key == "name").value;

      self.items = self.items.map((item) => {
        if (item.key == "name") {
            item.key = "Όνομα:";
        } else if (item.key == "service") {
            item.key = "Πρότυπο ISO:";
            item.value = item.value.name;
        } else if (item.key == "active") {
            item.key = "Κατάσταση:";
            if (item.value == 0) {
              item.value = "Ανενεργό";
            } else if (item.value == 1) {
              item.value = "Ενεργό";
            }
        } 

        return item;
      });
    }).catch(function (error) {
      console.log(error);
      self.$router.push({ path: '/login' });
    });
  }
}

</script>
